/** @jsx jsx */
import { jsx } from '@emotion/core';
import { background } from '@atlaskit/theme/colors';
import { BORDER_WIDTH } from './constants';

var IconWrapper = function IconWrapper(_ref) {
  var bgColor = _ref.bgColor,
      children = _ref.children;
  return jsx("span", {
    css: {
      alignContent: 'center',
      alignItems: 'center',
      backgroundColor: bgColor || background(),
      borderRadius: '50%',
      boxSizing: 'border-box',
      display: 'flex',
      height: '100%',
      overflow: 'hidden',
      border: "".concat(BORDER_WIDTH, "px solid ").concat(bgColor || background()),
      width: '100%'
    }
  }, children);
};

export default IconWrapper;